import React from "react";
import TokenIcon from "../../TokenIcon";
import { tokenNodeTypeObj, tokenTypeEnd } from "../../../utils/tokenNodeTypes";
import "./styles.scss";
import { AppConfig } from "../../../config";

export const CustomSelectOption = ({
  name,
  title,
  balanceValue,
  balanceUsd,
  currencyType,
  nodeType,
  identity,
}) => {

const tokenType = identity === 'wallet' && (
  <>
  {currencyType === 'token' ? tokenNodeTypeObj[nodeType] : null}
  {tokenTypeEnd(currencyType, nodeType, name)}
  </>
)
  return (
    <div className={`replenish__modal-container__select-option`}>
      <div className={`replenish__modal-container__select-option-main replenish__modal-container__select-option-main-${AppConfig.identity}`}>
        <TokenIcon
          tokenName={name}
          className="replenish__modal-container__select-option-main-logo"
        />
        <span>{title}</span>
      </div>
      <div className="replenish__modal-container__select-option-amount">
        <span className={`replenish__modal-container__select-option-amount-value replenish__modal-container__select-option-amount-value-${AppConfig.identity}`}>
          {balanceValue} {name} {tokenType}
        </span>
        <span className={`replenish__modal-container__select-option-amount-usd replenish__modal-container__select-option-amount-usd-${AppConfig.identity}`}>
          ${balanceUsd}
        </span>
      </div>
    </div>
  );
};